import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
  projectId: 'p418642410643419136',
  apiBaseUrl: 'https://api.lumi.new',
  authOrigin: 'https://auth.lumi.new',
})
